module.exports = __webpack_public_path__ + "static/img/26.d08b1556.png";